import { useTranslation } from 'react-i18next'

import { Box, Container, Stack, Typography } from '@mui/material'

import PageContainer from '@/components/ui/containers/PageContainer'

import CreateContractForm from './containers/CreateContractForm'

export function CreateContractPage() {
  const { t } = useTranslation()

  return (
    <Box>
      <Container maxWidth="xl">
        <Stack spacing={1} sx={{ pl: '30px', pr: '30px' }}>
          <Typography variant="h2" sx={{ mt: '30px', mb: '30px' }}>
            {t('page.createContract.title')}
          </Typography>
        </Stack>
      </Container>
      <PageContainer sx={{ '& > div': { paddingTop: 0 } }}>
        <CreateContractForm />
      </PageContainer>
    </Box>
  )
}

export default CreateContractPage
